const $ = require('jquery');
import _ from "underscore";
import run from '../../utilities/run';
import render from "../../utilities/render";
import {setElementsFromScope, setOptionsForSelect} from "../../utilities/selectorHelpers";

require("./standardPlatformFacilitySetupWizard.less");
// Additional Imports...

const modalHtml = require("../../sharedHtml/modal.html");
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { isBlank } from "../../utilities/general";

const elementsMap = {
  operationsfacbldtype:".fac-building-type",
  operationsfacuses:".fac-use-ops-section",
  operatonsfacceilinght:"#ceiling-height",
  operationsfacinshipdocks:"#ded-inbound-shipment",
  operationsfacoutshipdocks:"#ded-outbound-shipment",
  operationsfacshareddocks:"#shared-docks",
  operationsfacambient:"#AMBIENT",
  operationsfaccontrolled:"#CONTROLLED_ROOM_TEMPERATURE",
  operationsfaccooler:"#COOLER",
  operationsfacfreezer:"#FREEZER",
  operationsfactotalambient:"#total-sqfoot-AMBIENT",  
  operationsfacsumtotal:"#sum-total-sqfoot",
  operationsfacsumavail:"#sum-available-sqfoot",
  operationsfacsumutilize:"#sum-utilized-space",
  operationsfacavailambient:"#available-sqfoot-AMBIENT",
  operationsfacutilizeambient:"#utilized-space-AMBIENT",
  operationsfactotalcontrl:"#total-sqfoot-CONTROLLED_ROOM_TEMPERATURE",
  operationsfacavailcontrl:"#available-sqfoot-CONTROLLED_ROOM_TEMPERATURE",
  operationsfacutilizecontrl:"#utilized-space-CONTROLLED_ROOM_TEMPERATURE",
  operationsfactotalcooler:"#total-sqfoot-COOLER",
  operationsfacavailcooler:"#available-sqfoot-COOLER",
  operationsfacutilizecooler:"#utilized-space-COOLER",
  operationsfactotalfreezer:"#total-sqfoot-FREEZER",
  operationsfacavailfreezer:"#available-sqfoot-FREEZER",
  operationsfacutilizefreezer:"#utilized-space-FREEZER"
}
let els = {};

export default function OperationsTab(wizard){
  const self = this;
  const wizardEl = wizard.getWizardElement();
  const totalSqFtElement = wizardEl.find(".total-sqfoot");
  const sumOfTotalSqFtElement = wizardEl.find("#sum-total-sqfoot");
  const facilitySpaceCheckBox = wizardEl.find(".fac-space-name");
  const availableSqFtElement = wizardEl.find(".available-sqfoot");
  const sumOfAvailableSqFtElement = wizardEl.find("#sum-available-sqfoot");
  const sumUtilizationSpace = wizardEl.find("#sum-utilized-space");
  const facData = wizardEl.data("load-edit-facility");

 self.init = function(){
  setElements(); 
   load();
   loadOperationsEditForm(); //load saved facilities back to form 
 }

 function load(){

 }

 function setElements(){
  setElementsFromScope(els, elementsMap, wizardEl);
}

 facilitySpaceCheckBox.on('change', function(e){
  e.preventDefault();
  
  const totalSqFtEl = `#total-sqfoot-${e.target.id}`;
  const avlSqFtEl = `#available-sqfoot-${e.target.id}`;
  const errorEL =  `#total-sqfoot-${e.target.id}-error`;
  
  if($(this).is(":checked")){    
    $(totalSqFtEl).prop('disabled', false);
    $(totalSqFtEl).prop('required', true);
  }
  else{
    $(totalSqFtEl).prop('required', false);    
    $(errorEL).hide();     
    $(avlSqFtEl).val('');
    $(totalSqFtEl).prop('disabled', true).val('');
    $(totalSqFtEl).blur();
    //calculateTotalSqFt(e);
  }
});

 totalSqFtElement.on('blur', function(e){
   
   let avlSqFtEl = `#${e.target.id}`;
   avlSqFtEl = avlSqFtEl.replace('total-sqfoot-','available-sqfoot-');
   $(avlSqFtEl).val($(this).val());
   calculateTotalSqFt(e);   
 });


 function calculateTotalSqFt(e) {
   e.preventDefault();
   let totalSqFtVal = 0;
   totalSqFtElement.each(function() {
    totalSqFtVal += Number($(this).val());
   });
   if(totalSqFtVal == '0'){
    sumOfTotalSqFtElement.val('');
   }else{
    sumOfTotalSqFtElement.val(totalSqFtVal);
   }
   
   calculateAvailableSqFt(e);
   calculateSpaceUtilization(e);
 }

 function calculateAvailableSqFt(e) {
  e.preventDefault();
  let totalAvlSqFtVal = 0;
  availableSqFtElement.each(function() {
    totalAvlSqFtVal += Number($(this).val());
  });

  if(totalAvlSqFtVal == '0'){
    sumOfAvailableSqFtElement.val('');
   }else{
    sumOfAvailableSqFtElement.val(totalAvlSqFtVal);
   }
  
}
function calculateSpaceUtilization(e) {
  e.preventDefault();
  
  let totalSqFtEl = `#${e.target.id}`;
  let avlSqFtEl = totalSqFtEl.replace('total-sqfoot-','available-sqfoot-');
  let utlSpacePerEl = totalSqFtEl.replace('total-sqfoot-','utilized-space-');
  let utilizationSpace ;
  let utilizationPercent ;
 

  if( !isBlank($(totalSqFtEl).val()) && !isBlank($(avlSqFtEl).val()) &&
      !isNaN($(totalSqFtEl).val()) && !isNaN($(avlSqFtEl).val())
    ){    
    utilizationSpace = Number($(totalSqFtEl).val()) - Number($(avlSqFtEl).val());
  }
  if(utilizationSpace === undefined  ){
  } else if(!isNaN(utilizationSpace) && !isBlank($(totalSqFtEl).val())){
    utilizationPercent= utilizationSpace / Number($(totalSqFtEl).val());
  }

  if(utilizationPercent === undefined ||  isNaN(utilizationPercent)){   
    $(utlSpacePerEl).val('');
  }else if(!isNaN(utilizationPercent)){
    $(utlSpacePerEl).val(utilizationPercent * 100);
  }

  if(isBlank(sumOfTotalSqFtElement.val()) && isBlank(sumOfAvailableSqFtElement.val())){
    sumUtilizationSpace.val('');
  }else{
    sumUtilizationSpace.val(((Number(sumOfTotalSqFtElement.val()) - Number(sumOfAvailableSqFtElement.val()))/Number(sumOfTotalSqFtElement.val())) * 100);
  }
  
}

  function cancelSetupWizard(){
    window.location.href = els.cancelBtnUrl.data('redirect-to-url');
  }

  function loadOperationsEditForm(){
    if(facData != null && facData != ''){
      const facAttributesData = new Set(facData.facilitiesAttributesSet);

      if(facData.facBuildingType != null){
        _.each((els.operationsfacbldtype), (el)=>{
          const ele = $(el);
          if(ele.val() == facData.facBuildingType){
            ele.prop('checked', true);
          }           
        }); 
      }


      for (let keyval of facAttributesData) {
        let arr_names = new Array(keyval);
        for(let j=0;j<arr_names.length;j++){
          let attrName;
          let attrValue;
          for (let k of Object.keys(arr_names[j])) {
            if(k == "faaKey"){
              attrName = (arr_names[j])[k];
            }else if(k == "faaValue"){
              attrValue = (arr_names[j])[k];
            }

           }
           if(attrName!=null && attrValue!=null){
            if(attrName == "FAC_USE_ATTR"){
              let fcyuseselement = wizardEl.find('.fac-use-ops-box');
              _.each(fcyuseselement, (el)=>{  
                const ele = $(el);
                if(ele.val() == attrValue){
                  ele.prop('checked', true);
                }
              });
            }else if(attrName == "FAC_CEILING_HEIGHT_ATTR"){
             els.operatonsfacceilinght.val(attrValue);
            }else if(attrName == "FAC_INBOUND_SHIP_DOCKS_ATTR"){
              els.operationsfacinshipdocks.val(attrValue);
            }else if(attrName == "FAC_OUTBOUND_SHIP_DOCKS_ATTR"){
              els.operationsfacoutshipdocks.val(attrValue);
            }else if(attrName == "FAC_SHARED_DOCKS_ATTR"){
              els.operationsfacshareddocks.val(attrValue);
            }else if(attrName == "FAC_TOTAL_AMBIENT_ATTR"){
              els.operationsfacambient.prop('checked', true).trigger('change');
              els.operationsfactotalambient.val(attrValue);
            }else if(attrName == "FAC_AVAILABLE_AMBIENT_ATTR"){
              els.operationsfacavailambient.val(attrValue);
            }else if(attrName == "FAC_UTILIZED_AMBIENT_ATTR"){
              els.operationsfacutilizeambient.val(attrValue);
            }else if(attrName == "FAC_TOTAL_CONTROLLED_ROOM_TEMPERATURE_ATTR"){              
              els.operationsfaccontrolled.prop('checked', true).trigger('change');             
              els.operationsfactotalcontrl.val(attrValue);
            }else if(attrName == "FAC_AVAILABLE_CONTROLLED_ROOM_TEMPERATURE_ATTR"){
              els.operationsfacavailcontrl.val(attrValue);
            }else if(attrName == "FAC_UTILIZED_CONTROLLED_ROOM_TEMPERATURE_ATTR"){
              els.operationsfacutilizecontrl.val(attrValue);
            }else if(attrName == "FAC_TOTAL_COOLER_ATTR"){
              els.operationsfaccooler.prop('checked', true).trigger('change');
              els.operationsfactotalcooler.val(attrValue);
            }else if(attrName == "FAC_AVAILABLE_COOLER_ATTR"){
              els.operationsfacavailcooler.val(attrValue);
            }else if(attrName == "FAC_UTILIZED_COOLER_ATTR"){
              els.operationsfacutilizecooler.val(attrValue);
            }else if(attrName == "FAC_TOTAL_FREEZER_ATTR"){
              els.operationsfacfreezer.prop('checked', true).trigger('change');
              els.operationsfactotalfreezer.val(attrValue);
            }else if(attrName == "FAC_AVAILABLE_FREEZER_ATTR"){
              els.operationsfacavailfreezer.val(attrValue);
            }else if(attrName == "FAC_UTILIZED_FREEZER_ATTR"){
              els.operationsfacutilizefreezer.val(attrValue);
            }else if(attrName == "FAC_SUM_TOTAL_ATTR"){
              els.operationsfacsumtotal.val(attrValue);
            }else if(attrName == "FAC_SUM_AVAILABLE_ATTR"){
              els.operationsfacsumavail.val(attrValue);
            }else if(attrName == "FAC_SUM_UTILIZED_ATTR"){
              els.operationsfacsumutilize.val(attrValue);
            }
          }
        }  
      }
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/standardPlatformFacilitySetupWizard/operationsTab.js